import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Boxes } from "lucide-react";

export default function GoogleCallback() {
  const { refreshMe } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        if (!sessionId) throw new Error("no session");
        await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        await refreshMe();
        toast.success("Signed in with Google");
        navigate("/", { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [refreshMe, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <div className="w-10 h-10 bg-primary flex items-center justify-center animate-pulse">
        <Boxes className="w-6 h-6 text-primary-foreground" />
      </div>
      <div className="font-mono text-sm text-muted-foreground">Completing Google sign-in…</div>
    </div>
  );
}
